
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"59","height":"59.25","rx":"29.5","fill":"#E6EBFF"}}),_c('g',{attrs:{"clip-path":"url(#clip0_6162_103648)","fill":"#0037FF"}},[_c('path',{attrs:{"d":"M26.5 37h-6a.5.5 0 01-.5-.5v-14a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v6a1 1 0 002 0v-8a2.5 2.5 0 00-2.5-2.5h-9a2.5 2.5 0 00-2.5 2.5v19a2.5 2.5 0 002.5 2.5h6a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M24.88 33.75a.75.75 0 00.74-.75v-.3a.25.25 0 01.21-.24 2.09 2.09 0 00.35-4l-2.06-.82a.59.59 0 01.22-1.14h2a.75.75 0 100-1.5h-.5a.26.26 0 01-.26-.25v-.25a.75.75 0 00-.74-.75.76.76 0 00-.76.75v.3a.24.24 0 01-.2.24 2.09 2.09 0 00-.35 4l2.06.83a.59.59 0 01-.18 1.13h-2a.75.75 0 000 1.5h.5a.25.25 0 01.24.25V33a.76.76 0 00.73.75zM42 33.25a1.76 1.76 0 00-1.75-1.75h-10a1.76 1.76 0 00-1.75 1.75v7A1.76 1.76 0 0030.25 42h10A1.76 1.76 0 0042 40.25v-7zm-1.75 7.25h-10a.25.25 0 01-.25-.25v-3a.25.25 0 01.25-.25h10a.25.25 0 01.25.25v3a.25.25 0 01-.25.25zm-10-7.5h10a.25.25 0 01.25.25v1a.25.25 0 01-.25.25h-10a.25.25 0 01-.25-.25v-1a.25.25 0 01.25-.25z"}}),_c('path',{attrs:{"d":"M39 38.75a.76.76 0 00-.75-.75H37a.75.75 0 100 1.5h1.25a.76.76 0 00.75-.75z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6162_103648"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(18 18)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    